import type { OtpTokenPayload } from './types';

/**
 * Default auth data for dev auth.
 * Auth is processed via phone number. All other data used to add new saved passengers.
 * New saved passenger is determined via document number and type
 * So if you change this values, a new saved passenger will be added
 */
export const defaultAuthData: OtpTokenPayload = {
  phone: '+77007466489', // Phone must be real
  email: 'b0napartt@mail.ru', // Email must also be real
  first_name: 'grammist',
  last_name: 'Pro',
  gender: 'M',
  dob: '1999-12-11',
  citizenship: 'KZ',
  national_id: '123456789101',
  documents: [
    {
      first_name: 'Alen',
      last_name: 'Best',
      type: 'ПК',
      number: '04076023',
      expires_at: '2050-12-02',
    },
  ],
};

export const mockDataStorageKey = 'freedom:dev-auth';
